import { Fragment } from "react";
import { Divider, Typography } from "@mui/material";
import SideNavLink from "components/base/SideNavLink";
import { useUserData } from "features/User";

const GROUPBASELINK = '/profile/group';

export default function GroupManagementSideMenu() {
  const { groupId, groupRole } = useUserData();
  return (
    groupId != null &&
    groupRole === "OrganizationAdmin" && (
      <Fragment>
        <Divider />
        <Typography variant="h6" color="#5c6d7e" fontStyle="italic" mt={1.3}>
          Group Management
        </Typography>
        <SideNavLink to={`${GROUPBASELINK}/user-management`}>
          User Management
        </SideNavLink>
        <SideNavLink to={`${GROUPBASELINK}/add-users`}>
          Add Users
        </SideNavLink>
        <SideNavLink to={`${GROUPBASELINK}/analytics`}>
          Group Analytics
        </SideNavLink>
      </Fragment>
    )
  );
}
